import React from 'react'

export default ({ submitting, text, className = '', enabled = true, ...rest }) => (
  <button
    {...rest}
    disabled={submitting || !enabled}
    className={submitting ? className + " btn btn-function btn-loading" : className + " btn btn-function"}
    type="submit">
    {text}
  </button>
)